export const groupBuy = [
  {
    path: '/digitalMarketing/groupBuy',
    name: 'groupBuy',
    component: () => import('views/digitalMarketing/groupBuy/activityList'),
    meta: {
      title: '团购接龙',
      keepAlive: true
    }
  },
  {
    path: '/digitalMarketing/groupBuy/activityList/detail',
    name: 'groupActivityDetails',
    component: () => import('views/digitalMarketing/groupBuy/activityList/detail'),
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/selectGoods',
    name: 'groupBuySelectGoods',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/selectGoodsList'),
    meta: {
      title: '选择商品'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/addGoods',
    name: 'groupBuyAddGoods',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/addGoods'),
    meta: {
      title: '创建团购活动'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/createActivity',
    name: 'groupBuyCreateActivity',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/createActivity'),
    meta: {
      title: '创建团购活动'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/activityContent',
    name: 'groupBuyActivityContent',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/activityContent'),
    meta: {
      title: '活动说明'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/onlineStore',
    name: 'groupBuyOnlineStore',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/onlieStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/addByHand',
    name: 'groupBuyAddByHand',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/addGoodsHand'),
    meta: {
      title: '手动添加商品'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/editor',
    name: 'groupBuyEditor',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/editor'),
    meta: {
      title: '图文详情'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/addActivity/activityFinish',
    name: 'groupBuyActivityFinish',
    component: () => import('views/digitalMarketing/groupBuy/addActivity/activityFinish'),
    meta: {
      title: '分享活动'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/allOrderActivity',
    name: 'groupAllOrderActivity',
    component: () => import('views/digitalMarketing/groupBuy/allOrderActivity'),
    meta: {
      title: '活动订单',
      keepAlive: true
    }
  },
  {
    path: '/digitalMarketing/groupBuy/allOrderActivity/orderDetail',
    name: 'groupOrderDetail',
    component: () => import('views/digitalMarketing/groupBuy/allOrderActivity/orderDetail'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/allOrderActivity/bathHandleOrder',
    name: 'groupBathHandleOrder',
    component: () => import('views/digitalMarketing/groupBuy/allOrderActivity/bathHandleOrder'),
    meta: {
      title: '批量处理'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/goodsDetail',
    name: 'groupBuyGoodsDetail',
    component: () => import('views/digitalMarketing/groupBuy/activityList/detail/goodsDetail'),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/digitalMarketing/groupBuy/activityContent',
    name: 'groupViewActivityContent',
    component: () => import('views/digitalMarketing/groupBuy/activityList/detail/activityContent'),
    meta: {
      title: '活动说明'
    }
  }
]
